module.exports = new __parcel__URL__("card-amex.50e8c488.svg").toString();